module.exports = __webpack_public_path__ + "static/img/photo.d58db2cd.png";